$(document).ready(function () {
  try {
    $('form.catalog-form').on('submit', function (e) {
      e.preventDefault();

      const $recaptcha = $(this).find('.g-recaptcha');
      if ($recaptcha.length && window.not_robot === false) {
        return false;
      }

      // TEMP post to zapier
      const $form = $(this);
      const { action } = this.dataset;

      if (!action) return null;
      $.ajax({
        method: 'POST',
        url: action,
        data: $(this).serialize(),
      }).done(function (response) {
        // console.log("done", response)
        if (response.status === 'success') {
          const msg = $('.form-row__newsletter_result').data('success');
          $('.form-row__newsletter_result').html(msg).show();
          $form.trigger('reset');
        } else {
          $('.form-row__newsletter_result').html(response.status).show();
        }
      });
      return false;
    });
  } catch (e) {
    console.error('catalog js', e);
  }
});
